// import React, { useState, useEffect, useContext, useRef } from "react";
// import {
//   ArrowLeftOutlined,
//   DeleteOutlined,
//   PlusOutlined,
//   UploadOutlined,
// } from "@ant-design/icons";
// import { Form, Input, Select, DatePicker, Button, message, Modal } from "antd";
// import dayjs from "dayjs";
// import { useNavigate } from "react-router-dom";
// import { AuthContext } from "../../Auth/AuthContext";
// import {
//   addTask,
//   getallBoard,
//   getallDeveloperForTask,
//   getallReporterLoginUser,
//   getProjectName,
// } from "../../utils/API";
// import { addTaskLocal } from "../store/slice/taskSlice";
// import { useDispatch } from "react-redux";

// // TipTap imports
// import { useEditor, EditorContent } from "@tiptap/react";
// import StarterKit from "@tiptap/starter-kit";
// import Image from "@tiptap/extension-image";
// import Underline from "@tiptap/extension-underline";
// import Link from "@tiptap/extension-link";
// import TextAlign from "@tiptap/extension-text-align";
// import Placeholder from "@tiptap/extension-placeholder";
// import Heading from "@tiptap/extension-heading";
// import BulletList from "@tiptap/extension-bullet-list";

// // Custom image extension with size control
// const CustomImage = Image.extend({
//   addAttributes() {
//     return {
//       width: {
//         default: 150, // Default smaller width (number of pixels)
//       },
//       height: {
//         default: "auto",
//       },
//       // Include any existing attributes from the base Image extension if needed
//       // You can manually copy known attributes here if required
//       src: {},
//       alt: {},
//       title: {},
//     };
//   },
// });
// interface Board {
//   _id: string;
//   name: string;
//   slug?: string;
// }

// interface TaskFormModalProps {
//   visible: boolean;
//   onClose: () => void;
//   onTaskCreated: () => void;
// }

// const { Option } = Select;

// const TaskFormModal: React.FC<TaskFormModalProps> = ({
//   visible,
//   onClose,
//   onTaskCreated,
// }) => {
//   const [form] = Form.useForm();
//   const [isLoading, setIsLoading] = useState(false);
//   const [developers, setDevelopers] = useState<
//     { _id: string; username: string }[]
//   >([]);
//   const [reporters, setReporters] = useState<
//     { _id: string; reporterName: string }[]
//   >([]);
//   const [boards, setBoards] = useState<any>([]);
//   const [descValue, setDescValue] = useState("");
//   const [uploadedImages, setUploadedImages] = useState<File[]>([]);
//   const [ProjectName, setProjectName] = useState<any>([]);
//   const [linkUrl, setLinkUrl] = useState("");
//   const [showLinkInput, setShowLinkInput] = useState(false);
//   const [datePickerOpen, setDatePickerOpen] = useState(false);
//   const { authData } = useContext(AuthContext);
//   const isAdmin = authData.roleId?.roleId === 1;
//   const dispatch = useDispatch();

//   const editor = useEditor({
//     extensions: [
//       StarterKit.configure({
//         heading: false, // disable internal so we add our own
//         bulletList: false,
//         orderedList: false,
//       }),

//       Heading.configure({
//         levels: [1, 2, 3],
//       }),

//       BulletList.configure({
//         keepMarks: true,
//         keepAttributes: false,
//       }),

//       Underline,
//       Link.configure({
//         openOnClick: true,
//         HTMLAttributes: { class: "text-blue-500 underline" },
//       }),

//       Image.extend({
//         addAttributes() {
//           return {
//             src: { default: null },
//             alt: { default: null },
//             title: { default: null },
//             width: {
//               default: 300,
//               renderHTML: (attributes: any) => ({
//                 width: attributes.width,
//                 style: `width: ${attributes.width}px; height: auto; max-width: 100%;`,
//               }),
//             },
//             height: { default: "auto" },
//           };
//         },
//       }).configure({
//         inline: false,
//         HTMLAttributes: {
//           class: "rounded-md",
//           style: "max-width: 100%; height: auto;",
//         },
//       }),

//       TextAlign.configure({
//         types: ["heading", "paragraph"],
//       }),

//       Placeholder.configure({
//         placeholder: "Enter task description...",
//       }),
//     ],

//     content: descValue || "",

//     onUpdate: ({ editor }) => {
//       const html = editor.getHTML();
//       setDescValue(html);
//     },

//     editorProps: {
//       handlePaste(view, event) {
//         const items = Array.from(event.clipboardData?.items || []);
//         let imageProcessed = false;

//         for (const item of items) {
//           if (item.type.startsWith("image/")) {
//             event.preventDefault();
//             const file = item.getAsFile();
//             if (!file) continue;

//             setUploadedImages((prev) => [...prev, file]);

//             const reader = new FileReader();
//             reader.onload = () => {
//               const transaction = view.state.tr.insert(
//                 view.state.selection.from,
//                 view.state.schema.nodes.image.create({
//                   src: reader.result,
//                   alt: "Pasted image",
//                   title: "Pasted image",
//                   width: 300,
//                 })
//               );
//               view.dispatch(transaction);
//             };
//             reader.readAsDataURL(file);
//             imageProcessed = true;
//             break;
//           }
//         }
//         return imageProcessed;
//       },

//       handleDrop(view, event) {
//         if (event.dataTransfer?.files) {
//           const files = Array.from(event.dataTransfer.files);
//           let imageProcessed = false;

//           files.forEach((file) => {
//             if (file.type.startsWith("image/")) {
//               event.preventDefault();
//               imageProcessed = true;

//               setUploadedImages((prev) => [...prev, file]);

//               const reader = new FileReader();
//               reader.onload = () => {
//                 const coordinates = view.posAtCoords({
//                   left: event.clientX,
//                   top: event.clientY,
//                 });

//                 if (coordinates) {
//                   const transaction = view.state.tr.insert(
//                     coordinates.pos,
//                     view.state.schema.nodes.image.create({
//                       src: reader.result,
//                       alt: file.name,
//                       title: file.name,
//                       width: 300,
//                     })
//                   );
//                   view.dispatch(transaction);
//                 }
//               };
//               reader.readAsDataURL(file);
//             }
//           });

//           return imageProcessed;
//         }
//         return false;
//       },
//     },
//   });

//   // Replace the Toolbar component
//   const Toolbar = () => {
//     if (!editor) return null;

//     return (
//       <div className="border-b border-gray-200 p-2 flex flex-wrap items-center gap-1 bg-gray-50">
//         {/* Text formatting */}
//         <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
//           <Button
//             type={editor.isActive("bold") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleBold().run()}
//             title="Bold"
//           >
//             <strong>B</strong>
//           </Button>
//           <Button
//             type={editor.isActive("italic") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleItalic().run()}
//             title="Italic"
//           >
//             <em>I</em>
//           </Button>
//           <Button
//             type={editor.isActive("underline") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleUnderline().run()}
//             title="Underline"
//           >
//             <u>U</u>
//           </Button>
//           <Button
//             type={editor.isActive("strike") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleStrike().run()}
//             title="Strikethrough"
//           >
//             <s>S</s>
//           </Button>
//         </div>

//         {/* Headings */}
//         <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
//           <Button
//             type={
//               editor.isActive("heading", { level: 1 }) ? "primary" : "default"
//             }
//             size="small"
//             onClick={() =>
//               editor.chain().focus().toggleHeading({ level: 1 }).run()
//             }
//             title="Heading 1"
//           >
//             H1
//           </Button>
//           <Button
//             type={
//               editor.isActive("heading", { level: 2 }) ? "primary" : "default"
//             }
//             size="small"
//             onClick={() =>
//               editor.chain().focus().toggleHeading({ level: 2 }).run()
//             }
//             title="Heading 2"
//           >
//             H2
//           </Button>
//           <Button
//             type={
//               editor.isActive("heading", { level: 3 }) ? "primary" : "default"
//             }
//             size="small"
//             onClick={() =>
//               editor.chain().focus().toggleHeading({ level: 3 }).run()
//             }
//             title="Heading 3"
//           >
//             H3
//           </Button>
//           <Button
//             type={editor.isActive("paragraph") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().setParagraph().run()}
//             title="Paragraph"
//           >
//             P
//           </Button>
//         </div>

//         {/* Lists */}
//         <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
//           <Button
//             type={editor.isActive("bulletList") ? "primary" : "default"}
//             size="small"
//             onClick={() => editor.chain().focus().toggleBulletList().run()}
//             title="Bullet List"
//           >
//             • List
//           </Button>
//         </div>

//         {/* Links */}
//         {/* <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
//           {showLinkInput ? (
//             <div className="flex items-center gap-1">
//               <Input
//                 size="small"
//                 placeholder="Enter URL"
//                 value={linkUrl}
//                 onChange={(e) => setLinkUrl(e.target.value)}
//                 style={{ width: 150 }}
//               />
//               <Button size="small" type="primary" onClick={setLink}>
//                 Add
//               </Button>
//               <Button size="small" onClick={unsetLink}>
//                 Remove
//               </Button>
//             </div>
//           ) : (
//             <Button
//               type={editor.isActive("link") ? "primary" : "default"}
//               size="small"
//               onClick={() => setShowLinkInput(true)}
//               title="Add Link"
//             >
//               🔗
//             </Button>
//           )}
//         </div> */}

//         {/* Media */}
//         <div className="flex items-center gap-1">
//           <Button
//             size="small"
//             onClick={addImage}
//             title="Insert Image"
//             icon={<UploadOutlined />}
//           >
//             Image
//           </Button>
//         </div>
//       </div>
//     );
//   };

//   const addImage = () => {
//     const input = document.createElement("input");
//     input.type = "file";
//     input.accept = "image/*";
//     input.multiple = true;
//     input.click();

//     input.onchange = () => {
//       const files = Array.from(input.files || []);
//       const imageFiles = files.filter((file) => file.type.startsWith("image/"));

//       // Add all images to uploaded images at once
//       setUploadedImages((prev) => [...prev, ...imageFiles]);

//       // Insert images one by one
//       imageFiles.forEach((file) => {
//         const reader = new FileReader();
//         reader.onload = () => {
//           editor
//             ?.chain()
//             .focus()
//             .setImage({
//               src: reader.result as string,
//               alt: file.name,
//               title: file.name,
//               width: 300,
//             })
//             .run();
//         };
//         reader.readAsDataURL(file);
//       });
//     };
//   };
//   const handleDeadlineDateChange = (date: dayjs.Dayjs | null) => {
//     try {
//       // Update form value immediately
//       form.setFieldValue('deadlineDate', date);

//       // Optional: Show feedback to user
//       // if (date) {
//       //   message.success(`Deadline set to: ${date.format('DD-MM-YYYY HH:mm')}`, 2);
//       // }

//       // Auto-close the picker after a short delay
//       setTimeout(() => {
//         setDatePickerOpen(false);
//       }, 300);
//     } catch (error) {
//       console.error('Error setting deadline date:', error);
//     }
//   };
//   // Fetch boards
//   useEffect(() => {
//     const fetchBoards = async () => {
//       const response = await getallBoard("", 1);
//       setBoards(response.data);
//     };
//     fetchBoards();
//   }, []);

//   // Fetch devs + reporters
//   useEffect(() => {
//     const fetchDevelopers = async () => {
//       try {
//         const response: any = await getallDeveloperForTask("", "");
//         setDevelopers(response?.data || []);
//       } catch {
//         message.error("Failed to load developers");
//         setDevelopers([]);
//       }
//     };

//     const fetchReporters = async () => {
//       try {
//         const response: any = await getallReporterLoginUser("");
//         setReporters(response?.data || []);
//       } catch {
//         message.error("Failed to load reporters");
//         setReporters([]);
//       }
//     };
//     const fetchProjectNames = async () => {
//       try {
//         const response: any = await getProjectName();

//         // 🧠 Get full user auth data from localStorage
//         const authData = JSON.parse(localStorage.getItem("authData") || "{}");
//         const user = authData?.user;
//         const role = authData?.roleId;

//         const userId = user?._id;
//         const roleSlug = role?.slug?.toLowerCase(); // e.g., "team", "admin", etc.

//         let filteredProjects = response.data;

//         // ✅ Apply filter only for developers/team role
//         if (roleSlug === "team" || roleSlug === "developers") {
//           filteredProjects = response.data.filter(
//             (project: any) =>
//               Array.isArray(project.assignees) &&
//               project.assignees.some(
//                 (assignee: any) =>
//                   assignee === userId || assignee?._id === userId
//               )
//           );
//         }

//         setProjectName(filteredProjects);
//       } catch (error) {
//         console.error("Error fetching project names:", error);
//         message.error("Failed to load projects");
//         setProjectName([]);
//       }
//     };

//     fetchProjectNames();
//     fetchDevelopers();
//     fetchReporters();
//   }, []);

//   // Reset form when modal opens
//   useEffect(() => {
//     if (visible) {
//       setDescValue("");
//       editor?.commands.setContent("");
//       form.resetFields();
//       setUploadedImages([]);
//       setLinkUrl("");
//       setShowLinkInput(false);
//       setDatePickerOpen(false);

//       if (boards.length > 0) {
//         form.setFieldsValue({
//           boardId: boards.find((board: any) => board.slug === "to-do")?._id,
//         });
//       }
//     }
//   }, [visible, boards, form, editor]);

//   // Submit handler
//   const handleSubmit = async (values: any) => {
//     try {
//       setIsLoading(true);

//       const formData = new FormData();

//       const simpleFields = [
//         "userId",
//         "boardId",
//         "taskName",
//         "status",
//         "priority",
//         // "reporterId",
//       ];

//       simpleFields.forEach((field) => {
//         if (values[field] !== undefined && values[field] !== null) {
//           formData.append(field, values[field]);
//         }
//       });

//       const htmlContent = editor?.getHTML().trim() || "";
//       const plainText = editor?.getText().trim() || "";

//       if (!plainText) {
//         message.error("Please enter task description");
//         setIsLoading(false);
//         return;
//       }

//       // ✅ Send full HTML instead of plain text
//       formData.append("taskDesc", htmlContent);

//       uploadedImages.forEach((file: File) => {
//         formData.append("photo", file);
//       });

//       if (values.startDate) {
//         formData.append("startDate", values.startDate.format());
//       }
//       if (values.deadlineDate) {
//         formData.append("deadlineDate", values.deadlineDate.format());
//       }

//       formData.append("created", new Date().toISOString());

//       (values.assignees || []).forEach((assigneeId: string) => {
//         formData.append("assignees[]", assigneeId);
//       });

//       (values.subTasks || []).forEach((subtask: any, index: number) => {
//         formData.append(`subTasks[${index}][subTaskName]`, subtask.subTaskName);
//         formData.append(`subTasks[${index}][subTaskDesc]`, subtask.subTaskDesc);
//         formData.append(`subTasks[${index}][status]`, subtask.status);

//         (subtask.assignees || []).forEach((a: string, i: number) => {
//           formData.append(`subTasks[${index}][assignees][${i}]`, a);
//         });

//         formData.append(`subTasks[${index}][isActive]`, "true");
//       });

//       const response = await addTask(formData);
//       // console.log("Task creation response:", response);

//       dispatch(addTaskLocal(response.data));

//       if (response && (response.status === 201 || response.status === 200)) {
//         message.success("Task created successfully!");
//         setDescValue("");
//         setUploadedImages([]);
//         form.resetFields();

//         if (boards.length > 0) {
//           form.setFieldsValue({
//             boardId: boards.find((board: any) => board.slug === "to-do")?._id,
//           });
//         }

//         onTaskCreated();
//       } else {
//         message.error(response?.data?.message || "Failed to create task");
//       }
//     } catch (error: any) {
//       message.error(
//         "Task creation failed: " +
//         (error.response?.data?.message || "Server error")
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   //   useEffect(() => {
//   //     if (!editor) return;

//   //     const handleDrop = (event: DragEvent) => {
//   //       event.preventDefault();

//   //       const files = Array.from(event.dataTransfer?.files || []);
//   //       files.forEach((file) => {
//   //         if (!file.type.startsWith("image/")) return;

//   //         const reader = new FileReader();
//   //         reader.onload = () => {
//   //           //@ts-ignore
//   //           editor
//   //             .chain()
//   //             .focus()
//   //             .setImage({ src: reader.result as string, width: 200 })
//   //             .run();
//   //           setUploadedImages((prev) => [...prev, file]);
//   //         };
//   //         reader.readAsDataURL(file);
//   //       });
//   //     };

//   //     const handlePaste = (event: ClipboardEvent) => {
//   //       const items = Array.from(event.clipboardData?.items || []);
//   //       items.forEach((item) => {
//   //         if (item.type.indexOf("image") === -1) return;
//   //         const file = item.getAsFile();
//   //         if (!file) return;

//   //         const reader = new FileReader();
//   //         reader.onload = () => {
//   //           //@ts-ignore
//   //           editor
//   //             .chain()
//   //             .focus()
//   //             .setImage({ src: reader.result as string, width: 200 })
//   //             .run();
//   //           setUploadedImages((prev) => [...prev, file]);
//   //         };
//   //         reader.readAsDataURL(file);
//   //       });
//   //     };

//   //     const editorElement = editor.view.dom;
//   //     editorElement.addEventListener("drop", handleDrop);
//   //     editorElement.addEventListener("paste", handlePaste);

//   //     return () => {
//   //       editorElement.removeEventListener("drop", handleDrop);
//   //       editorElement.removeEventListener("paste", handlePaste);
//   //     };
//   //   }, [editor]);

//   return (
//     <Modal
//       open={visible}
//       onCancel={onClose}
//       footer={null}
//       width={700}
//       centered
//       className="custom-modal"
//       bodyStyle={{
//         overflowY: "auto",
//         fontFamily: "inter, sans-serif",
//       }}
//       styles={{
//         header: {
//           padding: "12px",
//           position: "sticky",
//           top: 0,
//           backgroundColor: "#f1f5ffff",
//         },
//         content: {
//           padding: 0,
//           overflow: "hidden",
//         },
//       }}
//       title={
//         <div
//           style={{
//             color: "#4b5563",
//             fontFamily: "inter, sans-serif",
//             fontSize: "20px",
//             fontWeight: 500,
//           }}
//         >
//           Create New Task
//         </div>
//       }
//     >
//       <Form
//         onFinish={handleSubmit}
//         form={form}
//         layout="horizontal"
//         labelCol={{ span: 4 }}
//         wrapperCol={{ span: 19 }}
//         colon={false}
//       >
//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 paddingLeft: "15px",
//                 fontWeight: 500,
//               }}
//             >
//               Board<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           name="boardId"
//           rules={[{ required: true, message: "Please select a board" }]}
//         >
//           <Select placeholder="Select Board" disabled={!isAdmin}>
//             {boards.map((board: any) => (
//               <Option key={board._id} value={board._id}>
//                 {board.name}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         {/* <Form.Item
//                     label={<span style={{
//                         color: '#4b5563', // Medium gray color similar to the image
//                         fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
//                         fontSize: '14px', // Approximate font size based on the image
//                         fontWeight: 500, // Medium weight to match "font-medium"
//                         paddingLeft: "15px",
//                     }}>Task Name<span className="text-red-500">*</span></span>}
//                     required={false}
//                     name="taskName"
//                     rules={[{ required: true, message: "Please enter task name" }]}
//                 >
//                     <Input placeholder="Enter task name" className="Allinput" />
//                 </Form.Item> */}

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 paddingLeft: "15px",
//               }}
//             >
//               Task Name<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           name="taskName"
//           rules={[{ required: true, message: "Please enter task name" }]}
//         >
//           <Select placeholder="Select Project" showSearch>
//             {ProjectName.map((p: any) => (
//               <Option key={p._id} value={p.projectName}>
//                 {p.projectName}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 paddingLeft: "15px",
//               }}
//             >
//               Description<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           rules={[{ required: true, message: "Please enter description" }]}
//         >
//           <div className="border rounded bg-white">
//             <Toolbar />
//             <div className="p-3">
//               <EditorContent
//                 editor={editor}
//                 className="min-h-[150px] outline-none"
//               />
//             </div>
//           </div>
//         </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563",
//                 fontFamily: "inter, sans-serif",
//                 fontSize: "14px",
//                 fontWeight: 500,
//                 paddingLeft: "15px",
//               }}
//             >
//               Deadline Date<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           name="deadlineDate"
//           rules={[{ required: true, message: "Please select deadline" }]}
//         >
//           <DatePicker
//             format="DD-MM-YYYY HH:mm"
//             className="w-full"
//             open={datePickerOpen}
//             onOpenChange={setDatePickerOpen}
//             onChange={(date) => {
//               if (date) {
//                 // When Now button is clicked, date will already have current time
//                 // When date is selected from calendar, set time to 10:00 AM
//                 const selectedHour = date.hour();
//                 const selectedMinute = date.minute();

//                 // Check if it's the default time (probably 0:00) or if user selected a time
//                 let dateWithTime;

//                 if (selectedHour === 0 && selectedMinute === 0) {
//                   // Default case - set to 10:00 AM
//                   dateWithTime = date.hour(10).minute(0).second(0);
//                 } else if (date.isSame(dayjs(), 'minute')) {
//                   // If it's exactly current time (Now button was clicked), keep it
//                   dateWithTime = date;
//                 } else {
//                   // For other cases, keep the selected time
//                   dateWithTime = date;
//                 }

//                 form.setFieldsValue({ deadlineDate: dateWithTime });
//                 handleDeadlineDateChange(dateWithTime);
//               }
//             }}
//             disabledDate={(current) => {
//               return current && current < dayjs().startOf('day');
//             }}
//             needConfirm={false}
//             showNow={true}
//             onOk={() => {
//               // Empty function - we don't need OK button
//             }}
//             // Remove showTime.defaultValue to prevent interfering with Now button
//             showTime={{}}
//             // Use defaultPickerValue instead to show 10:00 AM initially in the picker
//             // defaultPickerValue={dayjs().hour(10).minute(0).second(0)}
//             // Set initial form value to today at 10:00 AM
//             defaultValue={dayjs().hour(10).minute(0).second(0)}
//           />
//         </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563", // Medium gray color similar to the image
//                 fontFamily: "inter, sans-serif", // Matches the clean sans-serif style
//                 fontSize: "14px", // Approximate font size based on the image
//                 fontWeight: 500, // Medium weight to match "font-medium"
//                 paddingLeft: "15px",
//               }}
//             >
//               Priority<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           name="priority"
//           rules={[{ required: true, message: "Please select priority" }]}
//         >
//           <Select placeholder="Select Priority">
//             <Option value="Low">Low</Option>
//             <Option value="Medium">Medium</Option>
//             <Option value="High">High</Option>
//           </Select>
//         </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563", // Medium gray color similar to the image
//                 fontFamily: "inter, sans-serif", // Matches the clean sans-serif style
//                 fontSize: "14px", // Approximate font size based on the image
//                 fontWeight: 500, // Medium weight to match "font-medium"
//                 paddingLeft: "15px",
//               }}
//             >
//               Assignees<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           name="assignees"
//           rules={[
//             { required: true, message: "Please select at least one assignee" },
//           ]}
//         >
//           <Select
//             mode="multiple"
//             placeholder="Select Assignees"
//             filterOption={(input, option) =>
//               (option?.children ?? "")
//                 .toString()
//                 .toLowerCase()
//                 .includes(input.toLowerCase())
//             }
//           >
//             {developers.map((dev) => (
//               <Option key={dev._id} value={dev._id}>
//                 {dev.username}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563", // Medium gray color similar to the image
//                 fontFamily: "inter, sans-serif", // Matches the clean sans-serif style
//                 fontSize: "14px", // Approximate font size based on the image
//                 fontWeight: 500, // Medium weight to match "font-medium"
//                 paddingLeft: "15px",
//               }}
//             >
//               Reporter<span className="text-red-500"></span>
//             </span>
//           }
//           required={false}
//           name="reporterId"
//         >
//           <Select placeholder="Select Reporter">
//             {reporters.map((r) => (
//               <Option key={r._id} value={r._id}>
//                 {r.reporterName}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         <Form.Item
//           label={
//             <span
//               style={{
//                 color: "#4b5563", // Medium gray color similar to the image
//                 fontFamily: "inter, sans-serif", // Matches the clean sans-serif style
//                 fontSize: "14px", // Approximate font size based on the image
//                 fontWeight: 500, // Medium weight to match "font-medium"
//                 paddingLeft: "15px",
//               }}
//             >
//               SubTasks<span className="text-red-500">*</span>
//             </span>
//           }
//           required={false}
//           wrapperCol={{ span: 18 }}
//         >
//           <Form.List name="subTasks">
//             {(fields, { add, remove }) => (
//               <div>
//                 <Button
//                   type="dashed"
//                   icon={<PlusOutlined />}
//                   className="mb-3"
//                   onClick={() => add()}
//                 >
//                   Add Subtask
//                 </Button>
//                 {fields.map(({ key, name, ...restField }) => (
//                   <div
//                     key={key}
//                     className="border rounded p-3 mb-3 bg-white shadow-sm"
//                   >
//                     <div className="grid grid-cols-2 gap-3">
//                       <Form.Item {...restField} name={[name, "subTaskName"]}>
//                         <Input
//                           placeholder="Subtask name"
//                           className="Allinput "
//                         />
//                       </Form.Item>
//                       <Form.Item {...restField} name={[name, "subTaskDesc"]}>
//                         <Input placeholder="Description" className="Allinput" />
//                       </Form.Item>
//                       <Form.Item {...restField} name={[name, "status"]}>
//                         <Select placeholder="Status">
//                           <Option value="Pending">Pending</Option>
//                           <Option value="In Progress">In Progress</Option>
//                           <Option value="Completed">Completed</Option>
//                         </Select>
//                       </Form.Item>
//                       <Form.Item {...restField} name={[name, "assignees"]}>
//                         <Select mode="multiple" placeholder="Assignees">
//                           {developers.map((dev) => (
//                             <Option key={dev._id} value={dev._id}>
//                               {dev.username}
//                             </Option>
//                           ))}
//                         </Select>
//                       </Form.Item>
//                     </div>
//                     <Button danger type="text" onClick={() => remove(name)}>
//                       Remove
//                     </Button>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </Form.List>
//         </Form.Item>

//         <div className="flex justify-end gap-3 pr-5">
//           <button
//             type="button"
//             className="allcanclebutton"
//             onClick={onClose}
//             disabled={isLoading}
//           >
//             Cancel
//           </button>
//           <button className="allsubmitebutton" type="submit">
//             {isLoading ? "Adding..." : "Add"}
//           </button>
//         </div>
//       </Form>
//     </Modal>
//   );
// };

// export default TaskFormModal;

import React, { useState, useEffect, useContext, useRef } from "react";
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Form, Input, Select, DatePicker, Button, message, Modal, Switch, Row } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Auth/AuthContext";
import {
  addTask,
  getallBoard,
  getallDeveloperForTask,
  getallReporterLoginUser,
  getProjectName,
} from "../../utils/API";
import { addTaskLocal } from "../store/slice/taskSlice";
import { useDispatch } from "react-redux";

// TipTap imports
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Image from "@tiptap/extension-image";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import Placeholder from "@tiptap/extension-placeholder";
import Heading from "@tiptap/extension-heading";
import BulletList from "@tiptap/extension-bullet-list";

// Custom image extension with size control
const CustomImage = Image.extend({
  addAttributes() {
    return {
      width: {
        default: 150, // Default smaller width (number of pixels)
      },
      height: {
        default: "auto",
      },
      // Include any existing attributes from the base Image extension if needed
      // You can manually copy known attributes here if required
      src: {},
      alt: {},
      title: {},
    };
  },
});
interface Board {
  _id: string;
  name: string;
  slug?: string;
}

interface TaskFormModalProps {
  visible: boolean;
  onClose: () => void;
  onTaskCreated: () => void;
}

const { Option } = Select;

const TaskFormModal: React.FC<TaskFormModalProps> = ({
  visible,
  onClose,
  onTaskCreated,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [developers, setDevelopers] = useState<
    { _id: string; username: string }[]
  >([]);
  const [reporters, setReporters] = useState<
    { _id: string; reporterName: string }[]
  >([]);
  const [boards, setBoards] = useState<any>([]);
  const [descValue, setDescValue] = useState("");
  const [uploadedImages, setUploadedImages] = useState<File[]>([]);
  const [ProjectName, setProjectName] = useState<any>([]);
  const [linkUrl, setLinkUrl] = useState("");
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [notificationEnabled, setNotificationEnabled] = useState(false); // State for notification switch
  const { authData } = useContext(AuthContext);
  const isAdmin = authData.roleId?.roleId === 1;
  const dispatch = useDispatch();
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: false, // disable internal so we add our own
        bulletList: false,
        orderedList: false,
      }),

      Heading.configure({
        levels: [1, 2, 3],
      }),

      BulletList.configure({
        keepMarks: true,
        keepAttributes: false,
      }),

      Underline,
      Link.configure({
        openOnClick: true,
        HTMLAttributes: { class: "text-blue-500 underline" },
      }),

      Image.extend({
        addAttributes() {
          return {
            src: { default: null },
            alt: { default: null },
            title: { default: null },
            width: {
              default: 300,
              renderHTML: (attributes: any) => ({
                width: attributes.width,
                style: `width: ${attributes.width}px; height: auto; max-width: 100%;`,
              }),
            },
            height: { default: "auto" },
          };
        },
      }).configure({
        inline: false,
        HTMLAttributes: {
          class: "rounded-md",
          style: "max-width: 100%; height: auto;",
        },
      }),

      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),

      Placeholder.configure({
        placeholder: "Enter task description...",
      }),
    ],

    content: descValue || "",

    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      setDescValue(html);
    },

    editorProps: {
      handlePaste(view, event) {
        const items = Array.from(event.clipboardData?.items || []);
        let imageProcessed = false;

        for (const item of items) {
          if (item.type.startsWith("image/")) {
            event.preventDefault();
            const file = item.getAsFile();
            if (!file) continue;

            setUploadedImages((prev) => [...prev, file]);

            const reader = new FileReader();
            reader.onload = () => {
              const transaction = view.state.tr.insert(
                view.state.selection.from,
                view.state.schema.nodes.image.create({
                  src: reader.result,
                  alt: "Pasted image",
                  title: "Pasted image",
                  width: 300,
                })
              );
              view.dispatch(transaction);
            };
            reader.readAsDataURL(file);
            imageProcessed = true;
            break;
          }
        }
        return imageProcessed;
      },

      handleDrop(view, event) {
        if (event.dataTransfer?.files) {
          const files = Array.from(event.dataTransfer.files);
          let imageProcessed = false;

          files.forEach((file) => {
            if (file.type.startsWith("image/")) {
              event.preventDefault();
              imageProcessed = true;

              setUploadedImages((prev) => [...prev, file]);

              const reader = new FileReader();
              reader.onload = () => {
                const coordinates = view.posAtCoords({
                  left: event.clientX,
                  top: event.clientY,
                });

                if (coordinates) {
                  const transaction = view.state.tr.insert(
                    coordinates.pos,
                    view.state.schema.nodes.image.create({
                      src: reader.result,
                      alt: file.name,
                      title: file.name,
                      width: 300,
                    })
                  );
                  view.dispatch(transaction);
                }
              };
              reader.readAsDataURL(file);
            }
          });

          return imageProcessed;
        }
        return false;
      },
    },
  });

  // Replace the Toolbar component
  const Toolbar = () => {
    if (!editor) return null;

    return (
      <div className="border-b border-gray-200 p-2 flex flex-wrap items-center gap-1 bg-gray-50">
        {/* Text formatting */}
        <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          <Button
            type={editor.isActive("bold") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleBold().run()}
            title="Bold"
          >
            <strong>B</strong>
          </Button>
          <Button
            type={editor.isActive("italic") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleItalic().run()}
            title="Italic"
          >
            <em>I</em>
          </Button>
          <Button
            type={editor.isActive("underline") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleUnderline().run()}
            title="Underline"
          >
            <u>U</u>
          </Button>
          <Button
            type={editor.isActive("strike") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleStrike().run()}
            title="Strikethrough"
          >
            <s>S</s>
          </Button>
        </div>

        {/* Headings */}
        <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          <Button
            type={
              editor.isActive("heading", { level: 1 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 1 }).run()
            }
            title="Heading 1"
          >
            H1
          </Button>
          <Button
            type={
              editor.isActive("heading", { level: 2 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 2 }).run()
            }
            title="Heading 2"
          >
            H2
          </Button>
          <Button
            type={
              editor.isActive("heading", { level: 3 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 3 }).run()
            }
            title="Heading 3"
          >
            H3
          </Button>
          <Button
            type={editor.isActive("paragraph") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().setParagraph().run()}
            title="Paragraph"
          >
            P
          </Button>
        </div>

        {/* Lists */}
        <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          <Button
            type={editor.isActive("bulletList") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleBulletList().run()}
            title="Bullet List"
          >
            • List
          </Button>
        </div>

        {/* Media */}
        <div className="flex items-center gap-1">
          <Button
            size="small"
            onClick={addImage}
            title="Insert Image"
            icon={<UploadOutlined />}
          >
            Image
          </Button>
        </div>
      </div>
    );
  };

  const addImage = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.multiple = true;
    input.click();

    input.onchange = () => {
      const files = Array.from(input.files || []);
      const imageFiles = files.filter((file) => file.type.startsWith("image/"));

      // Add all images to uploaded images at once
      setUploadedImages((prev) => [...prev, ...imageFiles]);

      // Insert images one by one
      imageFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          editor
            ?.chain()
            .focus()
            .setImage({
              src: reader.result as string,
              alt: file.name,
              title: file.name,
              width: 300,
            })
            .run();
        };
        reader.readAsDataURL(file);
      });
    };
  };

  const handleDeadlineDateChange = (date: dayjs.Dayjs | null) => {
    try {
      // Update form value immediately
      form.setFieldValue('deadlineDate', date);

      // Auto-close the picker after a short delay
      setTimeout(() => {
        setDatePickerOpen(false);
      }, 300);
    } catch (error) {
      console.error('Error setting deadline date:', error);
    }
  };

  // Handle notification switch change
  const handleNotificationSwitch = (checked: boolean) => {
    setNotificationEnabled(checked);
    if (checked) {
      message.info('Notifications enabled for this task');
    } else {
      message.info('Notifications disabled for this task');
    }
  };

  // Fetch boards
  useEffect(() => {
    const fetchBoards = async () => {
      try {
        const response = await getallBoard("", 1);
        setBoards(response.data);
      } catch (error) {
        console.error("Failed to fetch boards", error);
        setBoards([]);
      }
    };
    fetchBoards();
  }, []);

  // Fetch devs + reporters
  useEffect(() => {
    const fetchDevelopers = async () => {
      try {
        const response: any = await getallDeveloperForTask("", "");
        setDevelopers(response?.data || []);
      } catch {
        message.error("Failed to load developers");
        setDevelopers([]);
      }
    };

    const fetchReporters = async () => {
      try {
        const response: any = await getallReporterLoginUser("");
        setReporters(response?.data || []);
      } catch {
        message.error("Failed to load reporters");
        setReporters([]);
      }
    };
    const fetchProjectNames = async () => {
      try {
        const response: any = await getProjectName();

        // Get full user auth data from localStorage
        const authData = JSON.parse(localStorage.getItem("authData") || "{}");
        const user = authData?.user;
        const role = authData?.roleId;

        const userId = user?._id;
        const roleSlug = role?.slug?.toLowerCase(); // e.g., "team", "admin", etc.

        let filteredProjects = response.data;

        // Apply filter only for developers/team role
        if (roleSlug === "team" || roleSlug === "developers") {
          filteredProjects = response.data.filter(
            (project: any) =>
              Array.isArray(project.assignees) &&
              project.assignees.some(
                (assignee: any) =>
                  assignee === userId || assignee?._id === userId
              )
          );
        }

        setProjectName(filteredProjects);
      } catch (error) {
        console.error("Error fetching project names:", error);
        message.error("Failed to load projects");
        setProjectName([]);
      }
    };

    fetchProjectNames();
    fetchDevelopers();
    fetchReporters();
  }, []);

  // Reset form when modal opens
  useEffect(() => {
    if (visible) {
      setDescValue("");
      editor?.commands.setContent("");
      form.resetFields();
      setUploadedImages([]);
      setLinkUrl("");
      setShowLinkInput(false);
      setDatePickerOpen(false);
      setNotificationEnabled(false); // Reset notification switch to off

      if (boards.length > 0) {
        form.setFieldsValue({
          boardId: boards.find((board: any) => board.slug === "to-do")?._id,
        });
      }
    }
  }, [visible, boards, form, editor]);

  // Submit handler
  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);

      const formData = new FormData();

      const simpleFields = [
        "userId",
        "boardId",
        "taskName",
        "status",
        "priority",
        // "reporterId",
      ];

      simpleFields.forEach((field) => {
        if (values[field] !== undefined && values[field] !== null) {
          formData.append(field, values[field]);
        }
      });

      const htmlContent = editor?.getHTML().trim() || "";
      const plainText = editor?.getText().trim() || "";
      const hasImages = /<img\b/i.test(htmlContent);

      if (!plainText && !hasImages) {
        message.error("Please enter a task description or upload an image");
        setIsLoading(false);
        return;
      }

      // Send full HTML instead of plain text
      formData.append("taskDesc", htmlContent);

      uploadedImages.forEach((file: File) => {
        formData.append("photo", file);
      });

      if (values.startDate) {
        formData.append("startDate", values.startDate.format());
      }
      if (values.deadlineDate) {
        formData.append("deadlineDate", values.deadlineDate.format());
      }

      formData.append("created", new Date().toISOString());

      // Add notification preference to form data
      formData.append("sendNotifications", String(notificationEnabled));

      (values.assignees || []).forEach((assigneeId: string) => {
        formData.append("assignees[]", assigneeId);
      });

      (values.subTasks || []).forEach((subtask: any, index: number) => {
        formData.append(`subTasks[${index}][subTaskName]`, subtask.subTaskName);
        formData.append(`subTasks[${index}][subTaskDesc]`, subtask.subTaskDesc);
        formData.append(`subTasks[${index}][status]`, subtask.status);

        (subtask.assignees || []).forEach((a: string, i: number) => {
          formData.append(`subTasks[${index}][assignees][${i}]`, a);
        });

        formData.append(`subTasks[${index}][isActive]`, "true");
      });

      const response = await addTask(formData);

      dispatch(addTaskLocal(response.data));

      if (response && (response.status === 201 || response.status === 200)) {
        // Show different success message based on notification preference
        if (notificationEnabled) {
          message.success("Task created successfully! Notifications will be sent.");
        } else {
          message.success("Task created successfully! (Notifications disabled)");
        }
        
        setDescValue("");
        setUploadedImages([]);
        form.resetFields();
        setNotificationEnabled(false);

        if (boards.length > 0) {
          form.setFieldsValue({
            boardId: boards.find((board: any) => board.slug === "to-do")?._id,
          });
        }

        onTaskCreated();
      } else {
        message.error(response?.data?.message || "Failed to create task");
      }
    } catch (error: any) {
      message.error(
        "Task creation failed: " +
        (error.response?.data?.message || "Server error")
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      centered
      className="custom-modal"
      bodyStyle={{
        overflowY: "auto",
        fontFamily: "inter, sans-serif",
      }}
      styles={{
        header: {
          padding: "12px",
          position: "sticky",
          top: 0,
          backgroundColor: "#f1f5ffff",
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Create New Task
        </div>
      }
    >
      <Form
        onFinish={handleSubmit}
        form={form}
        layout="horizontal"
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 19 }}
        colon={false}
      >
        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                paddingLeft: "15px",
                fontWeight: 500,
              }}
            >
              Board<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          name="boardId"
          rules={[{ required: true, message: "Please select a board" }]}
        >
          <Select placeholder="Select Board" disabled={!isAdmin}>
            {boards.map((board: any) => (
              <Option key={board._id} value={board._id}>
                {board.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Task Name<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          name="taskName"
          rules={[{ required: true, message: "Please enter task name" }]}
        >
          <Select placeholder="Select Project" showSearch>
            {ProjectName.map((p: any) => (
              <Option key={p._id} value={p.projectName}>
                {p.projectName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Description<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          rules={[{ required: true, message: "Please enter description" }]}
        >
          <div className="border rounded bg-white">
            <Toolbar />
            <div className="p-3">
              <EditorContent
                editor={editor}
                className="min-h-[150px] outline-none"
              />
            </div>
          </div>
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Deadline Date<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          name="deadlineDate"
          rules={[{ required: true, message: "Please select deadline" }]}
        >
          <DatePicker
            format="DD-MM-YYYY HH:mm"
            className="w-full"
            open={datePickerOpen}
            onOpenChange={setDatePickerOpen}
            onChange={(date) => {
              if (date) {
                const selectedHour = date.hour();
                const selectedMinute = date.minute();
                let dateWithTime;

                if (selectedHour === 0 && selectedMinute === 0) {
                  dateWithTime = date.hour(10).minute(0).second(0);
                } else if (date.isSame(dayjs(), 'minute')) {
                  dateWithTime = date;
                } else {
                  dateWithTime = date;
                }

                form.setFieldsValue({ deadlineDate: dateWithTime });
                handleDeadlineDateChange(dateWithTime);
              }
            }}
            disabledDate={(current) => {
              return current && current < dayjs().startOf('day');
            }}
            needConfirm={false}
            showNow={true}
            onOk={() => {}}
            showTime={{}}
            defaultValue={dayjs().hour(10).minute(0).second(0)}
          />
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Priority<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          name="priority"
          rules={[{ required: true, message: "Please select priority" }]}
        >
          <Select placeholder="Select Priority">
            <Option value="Low">Low</Option>
            <Option value="Medium">Medium</Option>
            <Option value="High">High</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Assignees<span className="text-red-500">*</span>
            </span>
          }
          required={false}
          name="assignees"
          rules={[
            { required: true, message: "Please select at least one assignee" },
          ]}
        >
          <Select
            mode="multiple"
            placeholder="Select Assignees"
            filterOption={(input, option) =>
              (option?.children ?? "")
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {developers.map((dev) => (
              <Option key={dev._id} value={dev._id}>
                {dev.username}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              Reporter
            </span>
          }
          required={false}
          name="reporterId"
        >
          <Select placeholder="Select Reporter">
            {reporters.map((r) => (
              <Option key={r._id} value={r._id}>
                {r.reporterName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span
              style={{
                color: "#4b5563",
                fontFamily: "inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                paddingLeft: "15px",
              }}
            >
              SubTasks
            </span>
          }
          required={false}
          wrapperCol={{ span: 18 }}
        >
          {/* Row container for Add Subtask button and Notification switch */}
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-4">
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() => {
                  const currentSubtasks = form.getFieldValue('subTasks') || [];
                  form.setFieldsValue({
                    subTasks: [...currentSubtasks, {}]
                  });
                }}
              >
                Add Subtask
              </Button>
            </div>
            
            {/* Notification Switch */}
            <div className="flex items-center gap-2">
              <span className="text-gray-600">Notifications</span>
              <Switch
                onChange={handleNotificationSwitch}
                checkedChildren="Enabled"
                unCheckedChildren="Disabled"
                defaultChecked={false}
                checked={notificationEnabled}
              />
            </div>
          </div>

          {/* Subtask List */}
          <Form.List name="subTasks">
            {(fields, { add, remove }) => (
              <div>
                {fields.map(({ key, name, ...restField }) => (
                  <div
                    key={key}
                    className="border rounded p-3 mb-3 bg-white shadow-sm"
                  >
                    <div className="grid grid-cols-2 gap-3">
                      <Form.Item 
                        {...restField} 
                        name={[name, "subTaskName"]}
                        rules={[{ required: true, message: "Subtask name required" }]}
                      >
                        <Input
                          placeholder="Subtask name"
                          className="Allinput"
                        />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, "subTaskDesc"]}>
                        <Input placeholder="Description" className="Allinput" />
                      </Form.Item>
                      <Form.Item 
                        {...restField} 
                        name={[name, "status"]}
                        initialValue="Pending"
                      >
                        <Select placeholder="Status">
                          <Option value="Pending">Pending</Option>
                          <Option value="In Progress">In Progress</Option>
                          <Option value="Completed">Completed</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item {...restField} name={[name, "assignees"]}>
                        <Select mode="multiple" placeholder="Assignees">
                          {developers.map((dev) => (
                            <Option key={dev._id} value={dev._id}>
                              {dev.username}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                    <Button danger type="text" onClick={() => remove(name)}>
                      Remove
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </Form.List>
        </Form.Item>

        <div className="flex justify-end gap-3 pr-5">
          <button
            type="button"
            className="allcanclebutton"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button className="allsubmitebutton" type="submit">
            {isLoading ? "Adding..." : "Add"}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default TaskFormModal;
